export interface WeddingCelebrationConfig {
  coupleId: string;
  personIds: Set<string>;
  displayNames: string;
  weddingDate: string;
  headline: string;
  subheadline: string;
  badges: string[];
  photoStems: string[];
  panelTagline: string;
  celebrationBadge: string;
  firstPlayCTA: string;
}

export interface FavoriteCousinConfig {
  personId: string;
  displayName: string;
  headline: string;
  subheadline: string;
  badges: string[];
  panelTagline: string;
  showsIconicPanel: boolean;
}

export interface RememberedConfig {
  personId: string;
  displayName: string;
  years: string;
  headline: string;
  subheadline: string;
  tribute: string;
  semicolonCaption: string;
  closingButton: string;
}

const WEDDINGS: WeddingCelebrationConfig[] = [
  {
    coupleId: "will-nathalie",
    personIds: new Set(["will-sundius", "nathalie-chavez"]),
    displayNames: "Will & Nathalie",
    weddingDate: "June 27, 2026",
    headline: "Just married!",
    subheadline:
      "Annapolis promised black-tie evenings and forever vows — June 27 made it official.",
    badges: ["Mr. & Mrs. Sundius", "Annapolis, MD", "Black Tie Forever"],
    photoStems: ["will-wedding-celebration-1", "will-wedding-celebration-2"],
    panelTagline: "Two hearts, one Sundius.\nCheers to Will & Nathalie.",
    celebrationBadge: "JUST MARRIED",
    firstPlayCTA: "Cheers to the happy couple! 🥂",
  },
  {
    coupleId: "ally-dustyn",
    personIds: new Set(["ally-stammire", "dustyn-stammire"]),
    displayNames: "Ally & Dustyn",
    weddingDate: "May 17, 2026",
    headline: "Just married!",
    subheadline:
      "South Carolina sunshine, a Minted love story, and a celebration worth every dance.",
    badges: ["Mrs. & Mr. Stammire", "Lexington, SC", "Happily Ever After"],
    photoStems: ["ally-wedding-celebration-1", "ally-wedding-celebration-2"],
    panelTagline: "Love won.\nCongratulations, Ally & Dustyn.",
    celebrationBadge: "JUST MARRIED",
    firstPlayCTA: "Cheers to the happy couple! 🥂",
  },
  {
    coupleId: "jack-jordynn",
    personIds: new Set(["jack-sundius", "jordynn-sundius"]),
    displayNames: "Jack & Jordynn",
    weddingDate: "January 4, 2026",
    headline: "They're engaged!",
    subheadline:
      "Jack proposed with a Ring Pop… that opened to a real engagement ring. Peak romance.",
    badges: ["Ring Pop Proposal", "She said yes!", "Candy → Forever"],
    photoStems: ["jack-engagement-celebration-1", "jack-engagement-celebration-2"],
    panelTagline: "A candy ring for the yes —\na real one for forever.",
    celebrationBadge: "JUST ENGAGED",
    firstPlayCTA: "Congrats to the newly engaged! 💍",
  },
];

const FAVORITES: Record<string, FavoriteCousinConfig> = {
  "victoria-rose": {
    personId: "victoria-rose",
    displayName: "Victoria",
    headline: "Your favorite cousin.",
    subheadline: "LA legend. Tulane grad. Glitter optional — excellence mandatory.",
    badges: ["#1 Cousin", "Certified Icon", "Not Up For Debate"],
    panelTagline: "Favorite cousin energy.\nCertified. Legendary. Not up for debate.",
    showsIconicPanel: true,
  },
  "kyle-auger": {
    personId: "kyle-auger",
    displayName: "Kyle",
    headline: "Your Favorite Cousin",
    subheadline:
      "Homes in New Hampshire. Trails in Patagonia. Nights in Tokyo. But honestly? The best miles are the ones back to you — weddings, reunions, and whatever chaos we're calling a family trip.",
    badges: ["Family First", "Chaos Mandatory", "Wedding RSVP: Yes"],
    panelTagline: "",
    showsIconicPanel: false,
  },
};

const REMEMBERED: Record<string, RememberedConfig> = {
  "robert-connolly": {
    personId: "robert-connolly",
    displayName: "Rob",
    years: "1984 — 2023",
    headline: "Still here, in every one of us.",
    subheadline:
      "Some people don't really leave when they go. They stay in the loud laughs, the old stories, the way this family keeps showing up for each other.",
    tribute:
      "You are the middle of the sentence, Rob — not the end of it. We carry your name, your fire, and your heart, and we always will.",
    semicolonCaption:
      "A semicolon is where a story could have stopped, but doesn't.\nYours keeps going in all of us. Loved beyond measure, missed every day.",
    closingButton: "Always loved, always here",
  },
};

export function weddingConfigFor(personId: string): WeddingCelebrationConfig | null {
  return WEDDINGS.find((c) => c.personIds.has(personId)) ?? null;
}

export function favoriteCousinConfigFor(personId: string): FavoriteCousinConfig | null {
  return FAVORITES[personId] ?? null;
}

export function rememberedConfigFor(personId: string): RememberedConfig | null {
  return REMEMBERED[personId] ?? null;
}
